import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackEvent, trackCustomEvent, PRODUCT } from '../utils/metaPixel';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  external?: boolean;
  /** Short label used to identify which CTA was clicked in the pixel events. */
  location: string;
  className?: string;
}
export function CtaButton({
  href,
  children,
  external = false,
  location,
  className = ''
}: CtaButtonProps) {
  const handleClick = () => {
    if (external) {
      trackEvent('InitiateCheckout', PRODUCT);
    } else {
      trackCustomEvent('ClickCTA', {
        location
      });
    }
  };
  return <a href={href} onClick={handleClick} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`group inline-flex w-full items-center justify-center gap-2 rounded-xl bg-accent px-4 py-4 text-center font-display text-[0.95rem] font-extrabold uppercase leading-tight tracking-wide text-white shadow-lg shadow-accent/30 transition-[transform,background-color,box-shadow] duration-150 ease-out hover:bg-accent-dark hover:shadow-xl active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent sm:px-6 sm:text-lg ${className}`} data-id="element-32" data-mp="109u1yi6kt9rx">
      <span data-id="element-33" data-mp="3jwnqw9rpqvj8">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-34" data-mp="3jxyr5zly9l5l" />
    </a>;
}